import {
    FETCH_PCVERSION,
    FETCH_PCVERSIONS,
} from '../actions/pcClient';


export const initialState = {
    isFetching: true,
    data: null
};

export const pcversions = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_PCVERSIONS}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_PCVERSIONS}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                pagination: {
                    total: action.payload.total,
                    defaultPageSize: action.payload.pageSize,
                    current: action.payload.page,
                },
                searchParams: action.meta.searchParams,
                extra: action.meta.extra,
                data: action.payload.data,
            });
        default:
            return state;
    }
}

export const pcversion = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_PCVERSION}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_PCVERSION}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                data: action.payload.data,
            });
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/pcClient.js